export const MODAL_KEYS = {
  EDIT_ASSET: 'EDIT_ASSET',
  UPLOAD_ASSET: 'UPLOAD_ASSET',
  LINK_CHANNEL: 'LINK_CHANNEL',
  Close_Caption: 'Close_Caption',
  SHOW_CLIP_USES: 'SHOW_CLIP_USES',
  EDIT_MULTIPLE_ASSETS: 'EDIT_MULTIPLE_ASSETS',
  SHOW_INGEST_STEPS: 'SHOW_INGEST_STEPS',
  ASSET_TIMELINE: 'ASSET_TIMELINE',
  DEMO: 'DEMO',
  CHANNEL_PREVIEW: 'CHANNEL_PREVIEW',
  SEGMENTS_IN_REPLAY: 'SEGMENTS_IN_REPLAY',
  CREATE_OU: 'CREATE_OU',
  OU_CATEGORY: 'OU_CATEGORY',
  FEED_CONFIG: 'FEED_CONFIG',
  FEED_VALIDATION_RESULT: 'FEED_VALIDATION_RESULT',
  IMPORT_CSV_FEED: 'IMPORT_CSV_FEED',
  SHOW_FEED_TASK: 'SHOW_FEED_TASK',
  SHOW_FEED_ITEM_TASK: 'SHOW_FEED_ITEM_TASK',
  DELETE_FEED_ITEM: 'DELETE_FEED_ITEM',
  MRSS_TEMPLATE: 'MRSS_TEMPLATE',
  EVENT_HANDLER: 'EVENT_HANDLER',
  EVENT_TEMPLATE: 'EVENT_TEMPLATE',
  AD_BANNER: 'AD_BANNER',
  USER_CREATION: 'USER_CREATION',
  ONE_BILL_SCRIPT_SNIPPET: 'ONE_BILL_SCRIPT_SNIPPET',
  APP_ANALYTICS_TOOLTIP: 'APP_ANALYTICS_TOOLTIP',
  LIVE_PREVIEW_INPUT: 'LIVE_PREVIEW_INPUT',
  INPUT_SOURCE_SETUP_HELP: 'INPUT_SOURCE_SETUP_HELP',
  LIVE_PREVIEW_BROADCAST: 'LIVE_PREVIEW_BROADCAST',
  CHANNEL_MONITORING: 'CHANNEL_MONITORING',
  BROADCAST_GEOFENCING: 'BROADCAST_GEOFENCING',
} as const;

export type ModalKey = (typeof MODAL_KEYS)[keyof typeof MODAL_KEYS];
